var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _polyline, _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoCbaLockup24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "91px",
    height: "24px",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 227 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 13.55,
    y1: 1923.56,
    x2: 51.1,
    y2: 1955.07,
    gradientTransform: "translate(0 -1907.31)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fef10c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#fde516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#fde113"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#fed508"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#fc0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 39.27,
    y1: 1948.09,
    x2: 50.94,
    y2: 1955.39,
    gradientTransform: "translate(0 -1907.31)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#874400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#d88a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#e79d00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#f2b400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#fad202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#fedf03"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.73,21.2c0-5.5,3-8.4,7.1-8.4,3,0,5.6,1.6,6,4.9h-2.5a3.28,3.28,0,0,0-3.5-2.7c-2.7,0-4.7,1.8-4.7,6.2s2,6.2,4.7,6.2a3.2,3.2,0,0,0,3.5-2.7h2.6c-.4,3.2-3.1,4.8-6,4.8C76.73,29.5,73.73,26.7,73.73,21.2Z",
    fill: "#1e1e1e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M87.93,23.4c0-3.8,2.3-6.2,5.5-6.2S99,19.6,99,23.4s-2.3,6.2-5.6,6.2S87.93,27.2,87.93,23.4Zm8.6,0c0-2.9-1.3-4.2-3.1-4.2s-3.1,1.4-3.1,4.2,1.3,4.2,3.1,4.2S96.53,26.2,96.53,23.4Z",
    fill: "#1e1e1e"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.43,21.5v7.7H115V21.8c0-1.9-.8-2.6-2.2-2.6s-2.7,1.2-2.7,3.3v6.7h-2.4V21.8c0-1.9-.8-2.6-2.2-2.6s-2.7,1.2-2.7,3.3v6.7h-2.4V17.5h2.4v1.8a3.92,3.92,0,0,1,3.5-2.1,3.67,3.67,0,0,1,3.5,2.3,3.93,3.93,0,0,1,3.8-2.3C115.73,17.2,117.43,18.6,117.43,21.5Z",
    fill: "#1e1e1e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M136.33,21.5v7.7h-2.4V21.8c0-1.9-.9-2.6-2.2-2.6-1.5,0-2.7,1.2-2.7,3.3v6.7h-2.4V21.8c0-1.9-.9-2.6-2.2-2.6-1.5,0-2.7,1.2-2.7,3.3v6.7h-2.4V17.5h2.4v1.8a3.92,3.92,0,0,1,3.5-2.1,3.45,3.45,0,0,1,3.4,2.3,3.93,3.93,0,0,1,3.8-2.3C134.63,17.2,136.33,18.6,136.33,21.5Z",
    fill: "#1e1e1e"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M137.93,23.4c0-3.8,2.3-6.2,5.5-6.2s5.6,2.4,5.6,6.2-2.3,6.2-5.6,6.2S137.93,27.2,137.93,23.4Zm8.6,0c0-2.9-1.3-4.2-3.1-4.2s-3.1,1.4-3.1,4.2,1.3,4.2,3.1,4.2S146.53,26.2,146.53,23.4Z",
    fill: "#1e1e1e"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M160.63,21.5v7.7h-2.4V22.1c0-2.1-1-2.8-2.4-2.8s-2.9,1-2.9,3.3v6.6h-2.4V17.5h2.4v1.9a4.13,4.13,0,0,1,3.7-2.2C158.73,17.2,160.63,18.6,160.63,21.5Z",
    fill: "#1e1e1e"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M175.43,17.5h2.4l-3,11.7h-2.9l-2.2-8.9-2.3,8.9h-2.9l-3-11.7h2.4l2.2,9.6,2.4-9.6h2.4l2.3,9.4Z",
    fill: "#1e1e1e"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M188.83,24h-8.3c.2,2.4,1.4,3.6,3.4,3.6a2.42,2.42,0,0,0,2.5-1.5h2.4a4.91,4.91,0,0,1-5,3.4c-3.3,0-5.6-2.4-5.6-6.2s2.3-6.2,5.7-6.2c3,0,5,1.9,5,5.6A6.15,6.15,0,0,0,188.83,24Zm-8.2-1.9h6c-.1-2.3-1.3-3-2.8-3a3.1,3.1,0,0,0-3.2,3Z",
    fill: "#1e1e1e"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M201.23,27.5v1.8a4.1,4.1,0,0,1-1.1.1,2.08,2.08,0,0,1-2.3-1.6,4.5,4.5,0,0,1-3.7,1.7,3.76,3.76,0,0,1-4.1-3.8c0-2.1,1.8-3.5,4-3.6l3.7-.1v-.6a2.11,2.11,0,0,0-1.8-2.3h-.5a2.34,2.34,0,0,0-2.6,1.7h-2.6c.5-2.4,2.3-3.6,5.1-3.6s4.6,1.6,4.6,4.1v5.2a.87.87,0,0,0,.9,1Zm-3.6-2.4V23.8l-3.2.2c-1.3.1-2.1.6-2.1,1.7s.8,2,2.3,2A2.74,2.74,0,0,0,197.63,25.1Z",
    fill: "#1e1e1e"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M202.63,29.3V13.1H205V29.3Z",
    fill: "#1e1e1e"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.83,46.2c0,3-2,4.6-5.4,4.6h-6.8V34.6h7c2.9,0,4.8,1.6,4.8,4.2a3.72,3.72,0,0,1-2.2,3.6A4.15,4.15,0,0,1,86.83,46.2ZM77,36.8v4.8h4.1c1.8,0,2.8-.8,2.8-2.4s-1-2.4-2.8-2.4Zm4.4,12c1.9,0,2.9-.9,2.9-2.5s-1-2.5-2.9-2.5H77v5.1h4.4Z",
    fill: "#1e1e1e"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99.13,49.1v1.8A4.1,4.1,0,0,1,98,51a2,2,0,0,1-2.3-1.6A4.5,4.5,0,0,1,92,51.1a3.73,3.73,0,0,1-4.1-3.4v-.4c0-2.3,1.8-3.5,4-3.6l3.7-.1V43a2.11,2.11,0,0,0-1.8-2.3h-.5a2.34,2.34,0,0,0-2.6,1.7h-2.6c.5-2.4,2.3-3.6,5.1-3.6,3,0,4.6,1.6,4.6,4.1v5.2a.87.87,0,0,0,.9,1Zm-3.6-2.4V45.4l-3.2.2c-1.3.1-2,.6-2,1.7s.8,2,2.3,2A2.72,2.72,0,0,0,95.53,46.7Z",
    fill: "#1e1e1e"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M110.43,43.1v7.7H108V43.7c0-2-1-2.8-2.3-2.8a3.08,3.08,0,0,0-3,3.3v6.6h-2.3V39.1h2.4V41a4.13,4.13,0,0,1,3.7-2.2C108.63,38.8,110.43,40.2,110.43,43.1Z",
    fill: "#1e1e1e"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M122.33,39.1l-5,5.7,5,6.1h-3l-4.6-5.7v5.7h-2.4V34.7h2.4v10l4.8-5.5Z",
    fill: "#1e1e1e"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M208.33,26.3V19.6h-2v-2h2V14.8l2.4-1.5v4.2h2.6v2h-2.6v6.1c0,1.2.5,1.6,1.4,1.6a5.7,5.7,0,0,0,1.3-.1v2a6.28,6.28,0,0,1-1.9.3,2.91,2.91,0,0,1-3.2-2.6Z",
    fill: "#1e1e1e"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M214.93,29.3V13.1h2.4v6.3a4.78,4.78,0,0,1,4.1-2.2c2.1,0,4,1.4,4,4.3v7.7H223V22.1a2.58,2.58,0,0,0-2.3-2.8h-.4a3,3,0,0,0-3,3.3v6.6h-2.4Z",
    fill: "#1e1e1e"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "32.33 0 64.33 32 32.33 64 0.33 32 32.33 0",
    fill: "url(#a)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "44.53 35.2 32.33 64 32.33 64 64.33 32 56.03 23.7 44.53 35.2",
    fill: "url(#b)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCbaLockup24);
export default __webpack_public_path__ + "static/media/logoCBALockup24.bd3dd9cddea5253753377f0decc7fcf3.svg";
export { ForwardRef as ReactComponent };